import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class TrackingUserFavoritesDealerMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._config = config
    this._culture = this._config.get('DEFAULT_CULTURE')
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
  }

  _getDealersProducts = products => {
    return products.map((each, index) => ({
      id: `dealer${each.id}`,
      category: 'dealer',
      list_position: index + 1
    }))
  }

  getTrackingData = ({products = [], ...trackingData}) => {
    const {TRACKING_TRANSLATIONS_BY_CULTURE} = this._config.get('tracking')
    const TRACKING_LITERALS = TRACKING_TRANSLATIONS_BY_CULTURE[this._culture]
    return {
      ...trackingData,
      page_name: TRACKING_LITERALS.USER_FAVORITE_DEALERS_PAGE_NAME,
      products: this._getDealersProducts(products)
    }
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {Object} param.data.products
   */
  map({page, culture, data}) {
    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({page, culture})
      .map(this.getTrackingData(data))
  }
}
